export class Building {
    constructor() {
        this.id = "";
        this.name = "";
        this.openHours = [];
        this.status = "";
    }
}
